import React from 'react';
import { PStarSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

const SLUG = 'abc-control-rule';

interface AbcControlRuleData {
  pStarValue?: number;
  dbPStarValue?: number;
  updatingPStar?: boolean;
  selectedStockId?: number | string | null;
}

export default function AbcControlRule(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<AbcControlRuleData>(props);

  const pageDbPStar = pageData?.data?.dbPStarValue as number | undefined;
  const pageUpdatingPStar = pageData?.data?.updatingPStar as boolean | undefined;
  const pageSelectedStockId = pageData?.data?.selectedStockId as number | string | null | undefined;

  const dbPStarValue = data.dbPStarValue ?? pageDbPStar ?? 0.35;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const pStarValue = formValue ?? data.pStarValue ?? dbPStarValue ?? 0.35;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(e.target.value);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  return (
    <PStarSlider
      pStarValue={pStarValue}
      dbPStarValue={dbPStarValue}
      handlePStarChange={handleChange}
      updatingPStar={data.updatingPStar ?? pageUpdatingPStar ?? false}
      selectedStockId={data.selectedStockId ?? pageSelectedStockId ?? null}
    />
  );
}
